import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { createColumnHelper } from "@tanstack/react-table";
import moment from "moment-timezone";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfo } from "@fortawesome/free-solid-svg-icons";
import StatusCell from "../../../../RetroAdjustment/StatusCell";
import { useCompanyDateFormat } from "../../../../../../utils/hooks/company";
import { renderSettingsResourceLabel } from "../../../../../../utils/helpers/settings";

const columnHelper = createColumnHelper();

export const useColumns = ({ openDetailsModal, date, user }) => {
    const { t } = useTranslation();
    const dateFormat = useCompanyDateFormat();

    return useMemo(() => {
        const columns = [
            columnHelper.accessor("startDate", {
                header: t("start-date"),
                cell: ({ row: { original } }) => {
                    return original?.startDate
                        ? moment.parseZone(original.startDate).format(dateFormat)
                        : null;
                }
            }),
            columnHelper.accessor("endDate", {
                header: t("end-date"),
                cell: ({ row: { original } }) => {
                    return original?.endDate
                        ? moment.parseZone(original.endDate).format(dateFormat)
                        : null;
                }
            }),
            columnHelper.accessor("payGroup", {
                header: t("pay-group"),
                cell: ({ row: { original } }) => {
                    const payGroup = original?.payGroup;
                    return (payGroup && typeof payGroup !== "string")
                        ? renderSettingsResourceLabel(payGroup)
                        : null;
                }
            }),
            columnHelper.accessor("status", {
                header: t("status"),
                cell: ({ row: { original } }) => <StatusCell original={original} />
            }),
            columnHelper.display({
                id: "actions",
                header: t("actions"),
                cell: ({ row: { original } }) => {
                    return (
                        <FontAwesomeIcon
                            className="cursor-pointer text-lg"
                            icon={faInfo}
                            onClick={() => openDetailsModal({ ...original, rowDate: date, user })}
                        />
                    );
                }
            })
        ];
        return columns;
    }, [t, dateFormat, openDetailsModal, date, user]);
}